<template>
  <div class="modal-inner">
    <div class="modal-close-button" @click="hide">
      ×
    </div>
    <div class="modal-background-green">
      <img class="modal-character-image" :src="fullImage" :alt="nameJp" :class="`modal-character-image-${keyName}`" />
      <div class="modal-background-filter">
        <div class="modal-character-profile">
          <p class="modal-character-profile-name modal-character-profile-name-jp">{{ nameJp }}</p>
          <p class="modal-character-profile-name modal-character-profile-name-en">{{ nameEn }}</p>
          <div class="modal-character-profile-heading-wrapper">
            <p class="modal-character-profile-age">
              <span class="modal-character-profile-span">年齢</span>
              {{ age }}
            </p>
            <p class="modal-character-profile-birthday">
              <span class="modal-character-profile-span">誕生日</span>
              {{ birthday }}
            </p>
          </div>
          <p class="modal-character-profile-description">{{ description }}</p>
          <div class="modal-character-profile-gallery">
            <div class="modal-character-profile-gallery-image">
              <img :src="gallery1" alt="gallery1" loading="lazy" />
            </div>
            <div class="modal-character-profile-gallery-image">
              <img :src="gallery2" alt="gallery2" loading="lazy" />
            </div>
            <div class="modal-character-profile-gallery-image">
              <img :src="gallery3" alt="gallery3" loading="lazy" />
            </div>
          </div>
          <div class="modal-character-profile-twitter">
            <a :href="`https://twitter.com/${twitterId}`" target="_blank" rel="noopener">
              <img src="../../assets/images/Twitter_Logo_Blue.png" alt="Twitterのロゴ" loading="lazy" />
              <span>@{{ twitterId }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CharacterModal',
  props: {
    keyName: String,
    nameJp: String,
    nameEn: String,
    fullImage: String,
    twitterId: String,
    gallery1: String,
    gallery2: String,
    gallery3: String,
    age: String,
    birthday: String,
    description: String
  },
  methods: {
    hide() {
      this.$modal.hide(`character-modal-${this.keyName}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../stylesheets/variables';

.modal {
  &-inner {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    color: $black;
    background-color: $white;
    background: linear-gradient(30deg, transparent 9%, $white 9.1%), linear-gradient(0deg, $white 0, $white 0),
      linear-gradient(210deg, transparent 9%, $white 9.1%), linear-gradient(0deg, $white 0, $white 0);
    background-position: bottom left, bottom right, top right, top left;
    background-size: 50% 50%;
    background-repeat: no-repeat;
  }

  &-close-button {
    font-size: 48px;
    color: $normal-bg;
    position: absolute;
    top: 4.6%;
    right: 4.3%;
    cursor: pointer;
  }

  &-background {
    &-green {
      background-color: $light-green;
      transform: skewY(10deg);
      height: 74.3%;
      margin-top: 9%;
      box-shadow: 0 4px 4px 0 rgba($color: $black, $alpha: 0.1) inset,
        0 -4px 4px 0 rgba($color: $black, $alpha: 0.1) inset;
    }

    &-filter {
      background-color: rgba($color: $white, $alpha: 0.6);
      width: 54.5%;
      height: 100%;
      margin-left: 39.6%;
      transform: skewY(-10deg);
      transform: skewX(12deg);
    }
  }

  &-character {
    &-image {
      position: absolute;
      transform: skewY(-10deg);

      &-tsumugi {
        width: auto;
        height: 100%;
        margin-left: -1.7%;
        filter: drop-shadow(-0.5em 0 0 rgba($color: $white, $alpha: 0.4));
      }

      &-musha {
        height: 85%;
        margin-top: 10.2%;
        margin-left: 3.5%;
        filter: drop-shadow(-0.9em 0 0 rgba($color: $white, $alpha: 0.4));
      }
    }

    &-profile {
      color: $normal-bg;
      transform: skew(-12deg, -10deg);

      &-name {
        &-jp {
          font-size: 36px;
          margin: 0;
        }

        &-en {
          color: $light-bg;
          font-size: 24px;
          margin: 0 0 0 7.6%;
        }
      }

      &-span {
        text-align: center;
        display: inline-block;
        color: $text-white;
        background: $normal-bg;
        width: 10.8%;
        padding: 0.6% 0;
        height: 100%;
        margin-right: 5.4%;
      }

      &-age {
        margin: 6.2% 0 0 7.6%;
      }

      &-birthday {
        margin: 1.6% 0 0 7.6%;
      }

      &-description {
        font-weight: 300;
        white-space: pre-line;
        width: 85%;
        margin: 3.1% 0 0 7.6%;
        padding-top: 3.2%;
        border-top: 1px solid $light-bg;
      }

      &-gallery {
        display: flex;
        justify-content: flex-end;
        margin: 3% 8% 0 0;

        &-image {
          width: 20%;
          margin-left: 6%;

          img {
            width: 100%;
            height: auto;
          }
        }
      }

      &-twitter {
        width: 42.6%;
        height: 7.6%;
        float: right;
        margin: 3% 8% 0 0;
        background-color: $normal-bg;

        a {
          color: $text-white;
          display: block;
          text-align: center;
          text-decoration: none;
          img {
            display: inline-block;
            vertical-align: middle;
            width: 15%;
            height: auto;
          }

          span {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .modal {
    &-inner {
      font-size: calc((1 / 355) * 100vw + (848 / 71) * 1px);
    }

    &-close-button {
      font-size: calc((2 / 71) * 100vw + (528 / 71) * 1px);
    }

    &-character {
      &-profile {
        &-name {
          &-jp {
            font-size: calc((6 / 355) * 100vw + (828 / 71) * 1px);
          }

          &-en {
            font-size: calc((2 / 213) * 100vw + (744 / 71) * 1px);
          }
        }

        &-heading-wrapper {
          font-size: calc((2 / 1065) * 100vw + (944 / 71) * 1px);
        }
      }
    }
  }
}
</style>
